import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.00061 6.85378L20.0003 3.46869L37.0001 6.85378V9.75528H3.00061V6.85378Z",
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.51819,
			y: 9.75505,
			width: 4.13787,
			height: 19.3434,
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.51819,
			y: 13.6247,
			width: 4.13787,
			height: 1.93434,
			fill: "#454A54"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 30.3478,
			y: 9.75505,
			width: 4.13787,
			height: 19.3434,
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 30.3478,
			y: 13.6247,
			width: 4.13787,
			height: 1.93434,
			fill: "#454A54"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.9301,
			y: 9.75505,
			width: 4.13787,
			height: 19.3434,
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.9301,
			y: 13.6247,
			width: 4.13787,
			height: 1.93434,
			fill: "#454A54"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.00122,
			y: 26.1975,
			width: 35.9994,
			height: 2.9015,
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 29.0985,
			width: 39.9994,
			height: 2.9015,
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00061,
			y: 9.75505,
			width: 33.9995,
			height: 3.86867,
			fill: "#454A54"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.9975,
			cy: 6.85313,
			rx: 7.08566,
			ry: 6.85313,
			fill: "#A3B1BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7398 9.6C19.6998 9.6 19.6658 9.586 19.6378 9.558C19.6098 9.53 19.5958 9.496 19.5958 9.456V9.036C19.2998 9.008 19.0498 8.938 18.8458 8.826C18.6418 8.71 18.4878 8.572 18.3838 8.412C18.2798 8.248 18.2238 8.078 18.2158 7.902C18.2158 7.866 18.2278 7.836 18.2518 7.812C18.2798 7.788 18.3118 7.776 18.3478 7.776H18.8818C18.9298 7.776 18.9678 7.788 18.9958 7.812C19.0238 7.832 19.0458 7.858 19.0618 7.89C19.0898 7.966 19.1358 8.042 19.1998 8.118C19.2678 8.19 19.3618 8.25 19.4818 8.298C19.6018 8.346 19.7518 8.37 19.9318 8.37C20.2198 8.37 20.4338 8.322 20.5738 8.226C20.7138 8.13 20.7838 8 20.7838 7.836C20.7838 7.72 20.7458 7.628 20.6698 7.56C20.5978 7.488 20.4818 7.424 20.3218 7.368C20.1618 7.308 19.9518 7.246 19.6918 7.182C19.3958 7.11 19.1458 7.024 18.9418 6.924C18.7378 6.82 18.5838 6.69 18.4798 6.534C18.3798 6.378 18.3298 6.18 18.3298 5.94C18.3298 5.632 18.4418 5.37 18.6658 5.154C18.8898 4.938 19.1998 4.806 19.5958 4.758V4.344C19.5958 4.304 19.6098 4.27 19.6378 4.242C19.6658 4.214 19.6998 4.2 19.7398 4.2H20.1058C20.1458 4.2 20.1798 4.214 20.2078 4.242C20.2358 4.27 20.2498 4.304 20.2498 4.344V4.77C20.5218 4.81 20.7498 4.89 20.9338 5.01C21.1178 5.13 21.2578 5.268 21.3538 5.424C21.4498 5.576 21.4998 5.724 21.5038 5.868C21.5038 5.9 21.4918 5.93 21.4678 5.958C21.4478 5.982 21.4178 5.994 21.3778 5.994H20.8198C20.7838 5.994 20.7498 5.986 20.7178 5.97C20.6858 5.954 20.6598 5.924 20.6398 5.88C20.6198 5.756 20.5438 5.65 20.4118 5.562C20.2798 5.474 20.1078 5.43 19.8958 5.43C19.6798 5.43 19.5058 5.47 19.3738 5.55C19.2458 5.63 19.1818 5.754 19.1818 5.922C19.1818 6.034 19.2138 6.128 19.2778 6.204C19.3418 6.276 19.4458 6.34 19.5898 6.396C19.7378 6.452 19.9338 6.512 20.1778 6.576C20.5178 6.652 20.7938 6.74 21.0058 6.84C21.2218 6.94 21.3798 7.068 21.4798 7.224C21.5838 7.376 21.6358 7.57 21.6358 7.806C21.6358 8.038 21.5778 8.242 21.4618 8.418C21.3498 8.59 21.1898 8.73 20.9818 8.838C20.7738 8.942 20.5298 9.01 20.2498 9.042V9.456C20.2498 9.496 20.2358 9.53 20.2078 9.558C20.1798 9.586 20.1458 9.6 20.1058 9.6H19.7398Z",
			fill: "#FFCE32"
		})
	]
});
export default SvgBankIcon;
